import { fromJS } from "immutable"
import { LOGIN_FAILED } from "../page-login/constants"
import { SIGNUP_FAILED } from "../page-signup/constants"
import { ERROR_CLOSE, ERROR_SHOW } from "./constants"
import { ACCEPT_TERM_OF_USE_FAILED } from "../page-finish-signup/constants"
export const initialState = fromJS(null)

function ErrorReducer(state = initialState, action) {
  switch (action.type) {
    case SIGNUP_FAILED:
    case LOGIN_FAILED:
    case ERROR_SHOW:
    case ACCEPT_TERM_OF_USE_FAILED:
      // scroll to top for mobile to visualize error
      window.scrollTo(0, 0)
      return fromJS({ ...action.payload })
    case ERROR_CLOSE:
      return initialState
    default:
      return state
  }
}

export default ErrorReducer
